const body = document.body;
const header = document.querySelector('.header');
const navToggle = document.querySelector('.nav-toggle');
const nav = document.querySelector('.header__nav');
const allNavItemContainer = document.querySelectorAll('.nav__item');
const allSubMenus = document.querySelectorAll('.nav__list__submenu');
const searchOpenButtons = document.querySelectorAll('.js-search-form-open');
const searchCloseButtons = document.querySelectorAll('.js-search-form-close');
const searchTints = document.querySelectorAll('.focus-tint');
const searchIcon = document.querySelector('.searchbar-icon');

window.addEventListener('load', function () {
    // trigger the scroll event to change the header bg color
    window.scrollTo(window.scrollX, window.scrollY - 1);
});

document.addEventListener('click', function () {
    closeAllSubmenu();
});

document.addEventListener('scroll', function () {
    const scrollPosition = window.scrollY;

    if (scrollPosition > 20) {
        header.classList.add('header--scrolled');
    } else {
        header.classList.remove('header--scrolled');
    }
});

window.addEventListener('resize', function () {
    closeAllSubmenu();
});

navToggle.addEventListener('click', () => {
    closeAllSubmenu();
    nav.classList.toggle('nav--visible');
    body.classList.toggle('showing-nav');
});

allNavItemContainer.forEach(item => {
    // I need this variable to get in the pointerdown event if this is a touch device or not.
    let deviceType = 'mouse';

    item.addEventListener('pointerdown', event => {
        // Get the device information (mouse, touch, or pen)
        deviceType = event.pointerType;
    });

    item.addEventListener('mouseenter', event => {
        if (deviceType === 'mouse') {
            openMenu(event.target);
        }
    });

    item.addEventListener('mouseleave', event => {
        if (deviceType === 'mouse') {
            closeMenu(event, event.target);
        }
    });

    item.addEventListener('click', event => {
        if (isMainLink(event.target)) {
            avoidDefaultBehavior(event);
        }

        if (deviceType === 'mouse') {
            if (isMainLink(event.target)) {
                mainMenuAction(event.target);
            }
        }
        if (deviceType === 'touch' || deviceType === 'pen') {
            if (isMainLink(event.target)) {
                const parentElement = event.target.closest('.nav__item');
                if (isOpen(parentElement)) {
                    closeMenu(event, parentElement);
                    mainMenuAction(event.target);
                } else {
                    openMenu(parentElement);
                }
            }
        }
    });
});

// Bind the theme events (theme.js)
searchOpenButtons.forEach(btn =>
    btn.addEventListener('click', theme.Header.functions.searchFormOpen.bind(theme.Header))
);

searchCloseButtons.forEach(btn =>
    btn.addEventListener('click', evt => {
        theme.Header.functions.searchFormClose.bind(theme.Header)(evt);
    })
);

searchTints.forEach(btn =>
    btn.addEventListener('click', evt => {
        evt.preventDefault();
        evt.stopPropagation();
        theme.Header.functions.onFocusTintClick.bind(theme.Header)(evt);
    })
);

searchIcon.addEventListener('click', event => {
    const searchFromContainer = event.target.closest('.search-bar__container');
    const searchForm = searchFromContainer.querySelector('.search-form');
    searchForm.submit();
});

function isMainLink(eventTarget) {
    const eventTargetClassList = Array.from(eventTarget.classList);
    return eventTargetClassList.includes('nav__main-link');
}

function isOpen(parentElement) {
    const subMenu = parentElement.querySelector('.nav__list__submenu');

    if (!subMenu) return;

    return subMenu.classList.contains('nav--visible');
}

function avoidDefaultBehavior(event) {
    event.preventDefault();
    event.stopPropagation();
}

function commonActionsOpenClose(subMenu, offsetWidth) {
    closeAllSubmenu(subMenu);
    const left = subMenu.clientWidth / 2 - offsetWidth / 2;
    subMenu.style.left = `-${left}px`;
}

function openMenu(parent) {
    const subMenu = parent.querySelector('.nav__list__submenu');

    if (!subMenu) return;

    subMenu.classList.add('nav--visible');

    commonActionsOpenClose(subMenu, event.target.offsetWidth);
}

function closeMenu(event, parent) {
    avoidDefaultBehavior(event);

    const subMenu = parent.querySelector('.nav__list__submenu');

    if (!subMenu) return;

    subMenu.classList.remove('nav--visible');
    commonActionsOpenClose(subMenu, event.target.offsetWidth);
}

function closeAllSubmenu(current) {
    allSubMenus.forEach(item => {
        if (current !== item) {
            item.classList.remove('nav--visible');
        }
    });
}

function isMobileVersion() {
    return window.getComputedStyle(navToggle).display !== 'none';
}

function mainMenuAction(item) {
    const href = item.getAttribute('href');
    if (href && href !== '#') {
        window.location.href = href;
    }
}
